<mat-progress-bar #passwordStrengthBar
                  [value]="percent"
                  [attr.title]="'password_strength ' + percent + '%' | translate"
                  tabindex="0">
</mat-progress-bar>
<mat-list role="list"
          mat-elevation-z0
          data-cy="password-complexity">
    <mat-list-item *ngFor="let rule of enabledRules"
                   [class.faded]="state[rule] != null"
                   [attr.data-cy]="'password-complexity-' + rule"
                   tabindex="0">
        <mat-icon *ngIf="state[rule] != null">check_circle</mat-icon>
        <mat-icon *ngIf="state[rule] == null"
                  color="primary">check_circle</mat-icon>
        {{ 'PasswordComplexity_' + rule | translate:{ min: passwordComplexity.length } }}
    </mat-list-item>
</mat-list>
